module.exports = __webpack_public_path__ + "static/media/colicoli23.72a6f151.webp";